import ClearingAPI from '@shared/api';

export const {
    rebalancingJob: { getTradeOrderListing },
    tradeOrders: { getTradeOrder },
} = ClearingAPI.settings;
